export const TYPES_THAT_SHOULD_BE_VIDEO: string[] = [
  'audio/webm',
  'audio/x-ms-wmv',
  'wmv',
  'webm',
]

export type FileTypeKeys =
  | 'images'
  | 'videos'
  | 'audios'
  | 'texts'
  | 'editableImages'

export const TYPE_MAPPING: { [key in FileTypeKeys]: string[] } = {
  images: [
    'image/x-png',
    'image/png',
    'image/gif',
    'image/jpeg',
    'image/svg+xml',
    'image/webp',
    'image/vnd.microsoft.icon',
    'image/tiff',
    'x-png',
    'png',
    'gif',
    'jpeg',
    'svg',
    'webp',
    'jpg',
    'tiff',
    'bmp',
    'ico',
    'jfif',
    'avif',
  ],

  videos: [
    'video/*',
    'application/mp4',
    'application/x-mpegurl',
    'application/vnd.apple.mpegurl',
    'audio/webm',
    'video/quicktime',
    'video/mp4',
    'mp4',
    'mov',
    'wmv',
    'flv',
    'avi',
    'webm',
    'mkv',
  ],

  audios: ['audio/*', 'aac', 'aiff', 'dsd', 'flac', 'mp3', 'mqa', 'wav', 'wma'],

  texts: [
    'application/msword',
    'application/x-iwork-pages-sffpages',
    'text/plain',
    'text/csv',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-excel',
    'application/rtf',
    'doc',
    'pdf',
    'docx',
    'rtf',
    'xls',
    'ppt',
    'csv',
  ],

  editableImages: [
    'image/x-png',
    'image/png',
    'image/jpeg',
    'x-png',
    'png',
    'jpeg',
    'jpg',
  ],
}

export const AVATAR_VALID_FORMATS = ['image/jpeg', 'image/png']
